/**
 * Stable CSS class names for E2E — Schedule detail card / detail section.
 */
export const SDD = {
    root: 'schedule-detail-card-details',
    header: 'schedule-detail-card-details__header',
    headerTitle: 'schedule-detail-card-details__header-title',

    detailRow: 'schedule-detail-card-details__row',
    detailRowJobId: 'schedule-detail-card-details__row--job-id',
    detailRowJobName: 'schedule-detail-card-details__row--job-name',
    detailRowTeam: 'schedule-detail-card-details__row--team',
    detailRowEmail: 'schedule-detail-card-details__row--email',

    detailTitle: 'schedule-detail-card-details__row-title',
    detailValue: 'schedule-detail-card-details__row-value',
    detailValueTooltip: 'schedule-detail-card-details__row-value-tooltip',

    statusRow: 'schedule-detail-card-details__status-row',
    statusBox: 'schedule-detail-card-details__status-box',
    statusTitle: 'schedule-detail-card-details__status-title',
    statusValue: 'schedule-detail-card-details__status-value',
    statusIconSuccess: 'schedule-detail-card-details__status-icon--success',
    statusIconError: 'schedule-detail-card-details__status-icon--error',
    statusIconTooltip: 'schedule-detail-card-details__status-icon-tooltip',
} as const;

export const sddCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

